module.exports = __webpack_public_path__ + "img/locate_arrow.53930786.png";